module.exports = __webpack_public_path__ + "static/media/img_system2.66224cf4.png";